export const ModifierTypes = {
    SINGLE: 'SINGLE',
    MULTIPLE: 'MULTIPLE',
} as const;

export type ModifierType = (typeof ModifierTypes)[keyof typeof ModifierTypes];
